// RouteLogger.js

import { createAccessLog, updateHeartbeat } from "components/axios/activityAxios";
import { getPrivateIP } from "data/data";
import MenuInfo from 'data/menu';
import { useEffect, useRef } from "react";
// import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const EXCLUDE_ACCESS_LOG_MENU_IDS = new Set([
    18600,
    18610,
    18620,
    18630
]);

export default function RouteLogger() {
    // const { t } = useTranslation();
    const location = useLocation();
    const prevPath = useRef("");
    const heartbeatRef = useRef(null);
    const heartbeatRunning = useRef(false);

    const sendHeartbeat = async () => {
        if (heartbeatRunning.current) {
            return;
        }

        heartbeatRunning.current = true;

        try {
            const accessLogId =
                sessionStorage.getItem("accessLogId");

            if (!accessLogId) {
                return;
            }
        
            await updateHeartbeat(accessLogId);
        } catch (e) {
            console.error(e);
        } finally {
            heartbeatRunning.current = false;
        }
    }

    useEffect(() => {
        const logRoute = async () => {
            try {
                const currentPath = location.pathname;

                if (prevPath.current === currentPath) {
                    return;
                }

                prevPath.current = currentPath;

                const menu = MenuInfo.ROOT.findDeepest(currentPath);
                // console.log(menu)
                if (!menu || menu.children?.length > 0) {
                    return;
                }
                if (EXCLUDE_ACCESS_LOG_MENU_IDS.has(menu.id)) {
                    return;
                }

                // 이전 heartbeat 제거
                if (heartbeatRef.current) {
                    clearInterval(heartbeatRef.current);
                    heartbeatRef.current = null;
                }
                await sendHeartbeat();

                const privateIp = await getPrivateIP();

                // console.log({
                //     menuId: menu.id,
                //     menuName: t(menu?.name),
                //     pageUrl: currentPath,
                //     privateIpAddress : privateIp
                // });

                const result = await createAccessLog({
                    menuId: menu.id,
                    menuName: menu?.name,
                    pageUrl: currentPath,
                    privateIpAddress : privateIp
                });

                const accessLogId = result?.id;
                // console.log("accessLogId", accessLogId);
                if (!accessLogId) {
                    return;
                }

                sessionStorage.setItem(
                    "accessLogId",
                    String(accessLogId)
                );

                // Heartbeat 시작 (1분)
                heartbeatRef.current = setInterval(
                    sendHeartbeat,
                    60000
                );
                
            } catch (error) {
                console.error("route log error", error);
            }
        };

        logRoute();

        return () => {
            if (heartbeatRef.current) {
                clearInterval(heartbeatRef.current);
                heartbeatRef.current = null;
            }
            // sessionStorage.removeItem("accessLogId");
        };
    
    }, [location.pathname]);

    return null;
}